module.exports = __webpack_public_path__ + "static/media/calendar-large.71aadd56.svg";